import React, { useRef, useState } from 'react'
import Layout from './Layout'
import Input from './Input'
import ButtonWithLoader from './ButtonWithLoader'
import { RootReducer } from '../redux/rootReducer'
import { useSelector } from 'react-redux'
import { UPDATE_TUTOR } from '../redux/tutorReducer'
import { useDispatch } from 'react-redux'
const UserScreen = () => {
  const reducerTutorData = useSelector((state: RootReducer) => state.tutorReducer)
  const dispatch = useDispatch()
  const [firstName, setFirstName] = useState(reducerTutorData.first_name)
  const [lastName, setLastName] = useState(reducerTutorData.last_name)
  const [email, setEmail] = useState(reducerTutorData.email)
  const [description, setDescription] = useState(reducerTutorData.description)
  const fileInputRef = useRef<HTMLInputElement>(null)
  const [profileImage, setProfileImage] = useState<string>(reducerTutorData.photo)
  const [pricePerHour, setPricePerHour] = useState<number>(reducerTutorData.price_per_h)
  const handleSubmit = () => {
    dispatch(
      UPDATE_TUTOR({
        first_name: firstName,
        last_name: lastName,
        description: description,
        email: email,
        photo: profileImage,
        price_per_h: pricePerHour
      })
    )
  }

  return (
    <Layout>
      <div className="px-2 ml--2 mr--2">
        <div className="h-10" />
        <h1 className="font-domine text-36 font-semibold">Update Your Profile</h1>
        <div className="flex flex-row gap-4 flex-wrap">
          <div className="flex-1 min-w-[350px]">
            <Input
              label="First Name"
              bgColor="white"
              color="darkIceBlue"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>
          <div className="flex-1 min-w-[350px]">
            <Input
              label="Last Name"
              bgColor="white"
              color="darkIceBlue"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
          <div className="flex-1 min-w-[350px]">
            <Input
              label="Email"
              bgColor="white"
              color="darkIceBlue"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="flex-1 min-w-[350px]">
            <Input
              label="Description"
              bgColor="white"
              color="darkIceBlue"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
        </div>
        <div className="h-5" />
        <div className="flex">
          <div className="">
            <Input
              label="Price per hour EUR"
              bgColor="white"
              color="darkIceBlue"
              type="number"
              value={pricePerHour.toString()}
              onChange={(e) => setPricePerHour(Number(e.target.value))}
            />
          </div>
          <div className="flex-1" />
        </div>
        <div className="flex justify-end">
          <div onClick={() => fileInputRef.current?.click()} className="cursor-pointer">
            <input
              onChange={(e) => {
                const file = e.target.files?.[0]
                const reader = new FileReader()
                reader.onload = (e) => {
                  const base64String = e.target?.result
                  setProfileImage(base64String as string)
                }
                if (file) {
                  reader.readAsDataURL(file)
                }
              }}
              type="file"
              ref={fileInputRef}
              className="hidden"
              accept=".jpg, .jpeg, .png"
            />
            <img
              className="w-24 h-24 rounded-full border-2 border-slateGray"
              src={profileImage}
              // src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ4f2X1fgjb1aD0oMN7qEF08stVzgu_y6J_OQ&s"
              alt="profile"
            />
            <div className="h-3" />
            <button className="font-sans text-16 font-semibold text-slateGray border-2 border-slateGray rounded-lg p-4">
              Upload
            </button>
          </div>
        </div>
        <div className="h-10" />
        <div className="flex justify-end">
          <div className="w-44">
            <ButtonWithLoader
              onClick={handleSubmit}
              isLoading={reducerTutorData.isLoading}
              customClass="bg-slateGray"
              label="Update"
            />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default UserScreen
